package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

@Serializable
data class AttendanceThresholdResponse(
    @SerialName("attendance_level") val attendanceLevel: String? = null,
    @SerialName("min_percentage") val minPercentage: Int? = null,
    @SerialName("max_percentage") val maxPercentage: Int? = null,
    @SerialName("display_order") val displayOrder: Int? = null,
    val id: String? = null
)

@Serializable
data class ExamGradeThresholdResponse(
    @SerialName("performance_level") val performanceLevel: String? = null,
    val grade: String? = null,
    @SerialName("min_percentage") val minPercentage: Int? = null,
    @SerialName("max_percentage") val maxPercentage: Int? = null,
    val id: String? = null
)

@Serializable
data class SchoolHolidayResponse(
    @SerialName("holiday_date") val holidayDate: String? = null,
    @SerialName("holiday_name") val holidayName: String? = null,
    val id: String? = null
)

@Serializable
data class HolidayImportResponse(
    @SerialName("total_rows") val totalRows: Int? = null,
    val imported: Int? = null,
    val skipped: Int? = null,
    val errors: List<String>? = null,
    val warnings: List<String>? = null
)

@Serializable
data class SchoolFeatureConfigResponse(
    @SerialName("feature_key") val featureKey: String? = null,
    @SerialName("is_enabled") val isEnabled: Boolean? = null,
    val settings: JsonObject? = null,
    val id: String? = null
)

@Serializable
data class SchoolConfigurationResponse(
    val id: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("academic_year_id") val academicYearId: String? = null,
    @SerialName("academic_year") val academicYear: String? = null,
    @SerialName("attendance_thresholds") val attendanceThresholds: List<AttendanceThresholdResponse>? = null,
    @SerialName("exam_grade_thresholds") val examGradeThresholds: List<ExamGradeThresholdResponse>? = null,
    val holidays: List<SchoolHolidayResponse>? = null,
    @SerialName("feature_configs") val featureConfigs: List<SchoolFeatureConfigResponse>? = null
)

@Serializable
data class SchoolWeeklyHolidayConfigResponse(
    @SerialName("day_of_week") val dayOfWeek: Int? = null,
    val id: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null
)
